export const COUNTRY_LIST = [
  'Afghanistan',
  'Albania',
  'Algeria',
  'Andorra',
  'Angola',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bhutan',
  'Bolivia',
  'Bosnia and Herzegovina',
  'Botswana',
  'Brazil',
  'Brunei',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cabo Verde',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Colombia',
  'Comoros',
  'Congo (Republic)',
  'Congo (Democratic Republic)',
  'Costa Rica',
  'Croatia',
  'Cuba',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Eswatini',
  'Ethiopia',
  'Fiji',
  'Finland',
  'France',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Greece',
  'Grenada',
  'Guatemala',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Honduras',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran',
  'Iraq',
  'Ireland',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  'Kuwait',
  'Kyrgyzstan',
  'Laos',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Mauritania',
  'Mauritius',
  'Mexico',
  'Micronesia',
  'Moldova',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'North Korea',
  'North Macedonia',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Poland',
  'Portugal',
  'Qatar',
  'Romania',
  'Russia',
  'Rwanda',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Korea',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Sweden',
  'Switzerland',
  'Syria',
  'Taiwan',
  'Tajikistan',
  'Tanzania',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Vatican City',
  'Venezuela',
  'Vietnam',
  'Yemen',
  'Zambia',
  'Zimbabwe',
] as const;

export const LANGUAGE_LIST = [
  'Arabic',
  'Bengali',
  'Bulgarian',
  'Burmese',
  'Chinese (Mandarin)',
  'Croatian',
  'Czech',
  'Danish',
  'Dutch',
  'English',
  'Estonian',
  'Farsi',
  'Finnish',
  'French',
  'Georgian',
  'German',
  'Greek',
  'Hebrew',
  'Hindi',
  'Hungarian',
  'Indonesian',
  'Italian',
  'Japanese',
  'Kazakh',
  'Khmer',
  'Korean',
  'Lao',
  'Latvian',
  'Lithuanian',
  'Malay',
  'Mongolian',
  'Norwegian',
  'Polish',
  'Portuguese',
  'Romanian',
  'Russian',
  'Serbian',
  'Sinhala',
  'Slovak',
  'Slovenian',
  'Spanish',
  'Swahili',
  'Swedish',
  'Tagalog',
  'Tamil',
  'Thai',
  'Turkish',
  'Ukrainian',
  'Urdu',
  'Vietnamese',
] as const;

export const COUNTRY_OPTIONS = COUNTRY_LIST.map((name) => ({
  value: name,
  label: name,
}));

export const LANGUAGE_OPTIONS = LANGUAGE_LIST.map((name) => ({
  value: name,
  label: name,
}));

// Comprehensive currency list for budget tracking
// Organized by region with popular currencies first
export const CURRENCY_LIST = [
  // Major World Currencies
  { code: 'USD', label: '🇺🇸 USD - US Dollar ($)', region: 'Americas' },
  { code: 'EUR', label: '🇪🇺 EUR - Euro (€)', region: 'Europe' },
  { code: 'GBP', label: '🇬🇧 GBP - British Pound (£)', region: 'Europe' },
  { code: 'JPY', label: '🇯🇵 JPY - Japanese Yen (¥)', region: 'Asia' },
  { code: 'CNY', label: '🇨🇳 CNY - Chinese Yuan (¥)', region: 'Asia' },
  { code: 'CHF', label: '🇨🇭 CHF - Swiss Franc', region: 'Europe' },
  
  // Americas
  { code: 'CAD', label: '🇨🇦 CAD - Canadian Dollar (C$)', region: 'Americas' },
  { code: 'MXN', label: '🇲🇽 MXN - Mexican Peso (MX$)', region: 'Americas' },
  { code: 'BRL', label: '🇧🇷 BRL - Brazilian Real (R$)', region: 'Americas' },
  { code: 'ARS', label: '🇦🇷 ARS - Argentine Peso', region: 'Americas' },
  { code: 'CLP', label: '🇨🇱 CLP - Chilean Peso', region: 'Americas' },
  { code: 'COP', label: '🇨🇴 COP - Colombian Peso', region: 'Americas' },
  { code: 'PEN', label: '🇵🇪 PEN - Peruvian Sol', region: 'Americas' },
  { code: 'UYU', label: '🇺🇾 UYU - Uruguayan Peso', region: 'Americas' },
  { code: 'JMD', label: '🇯🇲 JMD - Jamaican Dollar', region: 'Americas' },
  { code: 'TTD', label: '🇹🇹 TTD - Trinidad Dollar', region: 'Americas' },
  
  // Europe
  { code: 'SEK', label: '🇸🇪 SEK - Swedish Krona', region: 'Europe' },
  { code: 'NOK', label: '🇳🇴 NOK - Norwegian Krone', region: 'Europe' },
  { code: 'DKK', label: '🇩🇰 DKK - Danish Krone', region: 'Europe' },
  { code: 'PLN', label: '🇵🇱 PLN - Polish Złoty (zł)', region: 'Europe' },
  { code: 'CZK', label: '🇨🇿 CZK - Czech Koruna', region: 'Europe' },
  { code: 'HUF', label: '🇭🇺 HUF - Hungarian Forint', region: 'Europe' },
  { code: 'RON', label: '🇷🇴 RON - Romanian Leu', region: 'Europe' },
  { code: 'BGN', label: '🇧🇬 BGN - Bulgarian Lev', region: 'Europe' },
  { code: 'HRK', label: '🇭🇷 HRK - Croatian Kuna', region: 'Europe' },
  { code: 'ISK', label: '🇮🇸 ISK - Icelandic Króna', region: 'Europe' },
  { code: 'RUB', label: '🇷🇺 RUB - Russian Ruble', region: 'Europe' },
  { code: 'UAH', label: '🇺🇦 UAH - Ukrainian Hryvnia', region: 'Europe' },
  { code: 'TRY', label: '🇹🇷 TRY - Turkish Lira (₺)', region: 'Europe' },
  
  // Asia Pacific
  { code: 'KRW', label: '🇰🇷 KRW - South Korean Won (₩)', region: 'Asia' },
  { code: 'INR', label: '🇮🇳 INR - Indian Rupee (₹)', region: 'Asia' },
  { code: 'SGD', label: '🇸🇬 SGD - Singapore Dollar (S$)', region: 'Asia' },
  { code: 'HKD', label: '🇭🇰 HKD - Hong Kong Dollar (HK$)', region: 'Asia' },
  { code: 'TWD', label: '🇹🇼 TWD - Taiwan Dollar (NT$)', region: 'Asia' },
  { code: 'THB', label: '🇹🇭 THB - Thai Baht (฿)', region: 'Asia' },
  { code: 'MYR', label: '🇲🇾 MYR - Malaysian Ringgit', region: 'Asia' },
  { code: 'PHP', label: '🇵🇭 PHP - Philippine Peso (₱)', region: 'Asia' },
  { code: 'IDR', label: '🇮🇩 IDR - Indonesian Rupiah', region: 'Asia' },
  { code: 'VND', label: '🇻🇳 VND - Vietnamese Dong (₫)', region: 'Asia' },
  { code: 'PKR', label: '🇵🇰 PKR - Pakistani Rupee', region: 'Asia' },
  { code: 'BDT', label: '🇧🇩 BDT - Bangladeshi Taka', region: 'Asia' },
  { code: 'LKR', label: '🇱🇰 LKR - Sri Lankan Rupee', region: 'Asia' },
  { code: 'NPR', label: '🇳🇵 NPR - Nepalese Rupee', region: 'Asia' },
  { code: 'MMK', label: '🇲🇲 MMK - Myanmar Kyat', region: 'Asia' },
  { code: 'KHR', label: '🇰🇭 KHR - Cambodian Riel', region: 'Asia' },
  { code: 'LAK', label: '🇱🇦 LAK - Lao Kip', region: 'Asia' },
  
  // Oceania
  { code: 'AUD', label: '🇦🇺 AUD - Australian Dollar (A$)', region: 'Oceania' },
  { code: 'NZD', label: '🇳🇿 NZD - New Zealand Dollar (NZ$)', region: 'Oceania' },
  { code: 'FJD', label: '🇫🇯 FJD - Fijian Dollar', region: 'Oceania' },
  
  // Middle East
  { code: 'AED', label: '🇦🇪 AED - UAE Dirham', region: 'Middle East' },
  { code: 'SAR', label: '🇸🇦 SAR - Saudi Riyal', region: 'Middle East' },
  { code: 'QAR', label: '🇶🇦 QAR - Qatari Riyal', region: 'Middle East' },
  { code: 'KWD', label: '🇰🇼 KWD - Kuwaiti Dinar', region: 'Middle East' },
  { code: 'BHD', label: '🇧🇭 BHD - Bahraini Dinar', region: 'Middle East' },
  { code: 'OMR', label: '🇴🇲 OMR - Omani Rial', region: 'Middle East' },
  { code: 'JOD', label: '🇯🇴 JOD - Jordanian Dinar', region: 'Middle East' },
  { code: 'ILS', label: '🇮🇱 ILS - Israeli Shekel (₪)', region: 'Middle East' },
  { code: 'EGP', label: '🇪🇬 EGP - Egyptian Pound', region: 'Middle East' },
  { code: 'LBP', label: '🇱🇧 LBP - Lebanese Pound', region: 'Middle East' },
  
  // Africa
  { code: 'ZAR', label: '🇿🇦 ZAR - South African Rand', region: 'Africa' },
  { code: 'MAD', label: '🇲🇦 MAD - Moroccan Dirham', region: 'Africa' },
  { code: 'NGN', label: '🇳🇬 NGN - Nigerian Naira', region: 'Africa' },
  { code: 'KES', label: '🇰🇪 KES - Kenyan Shilling', region: 'Africa' },
  { code: 'GHS', label: '🇬🇭 GHS - Ghanaian Cedi', region: 'Africa' },
  { code: 'TZS', label: '🇹🇿 TZS - Tanzanian Shilling', region: 'Africa' },
  { code: 'UGX', label: '🇺🇬 UGX - Ugandan Shilling', region: 'Africa' },
  { code: 'ETB', label: '🇪🇹 ETB - Ethiopian Birr', region: 'Africa' },
  { code: 'MUR', label: '🇲🇺 MUR - Mauritian Rupee', region: 'Africa' },
  { code: 'TND', label: '🇹🇳 TND - Tunisian Dinar', region: 'Africa' },
] as const;

export const CURRENCY_OPTIONS = CURRENCY_LIST.map(({ code, label }) => ({
  value: code,
  label,
}));

// Grouped currency options for better UX (can be used for sectioned lists)
export const CURRENCY_OPTIONS_BY_REGION = {
  'Popular': CURRENCY_LIST.filter(c => ['USD', 'EUR', 'GBP', 'JPY', 'CAD', 'AUD', 'CHF'].includes(c.code)),
  'Americas': CURRENCY_LIST.filter(c => c.region === 'Americas'),
  'Europe': CURRENCY_LIST.filter(c => c.region === 'Europe'),
  'Asia': CURRENCY_LIST.filter(c => c.region === 'Asia'),
  'Oceania': CURRENCY_LIST.filter(c => c.region === 'Oceania'),
  'Middle East': CURRENCY_LIST.filter(c => c.region === 'Middle East'),
  'Africa': CURRENCY_LIST.filter(c => c.region === 'Africa'),
};


